export default __webpack_public_path__ + "static/media/Hand Holding Cell Phone 1.3e6d1f89.png";